exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.comps-audit-log-modal-table-title[data-v-5341f4e9] {\r\n  font-weight: 600;\n}\r\n", ""]);

// exports
